import React from 'react';
import { client } from './client';
import { ApolloProvider } from '@apollo/client/react';

export const wrapRootElement = ({ element }) => (
    <ApolloProvider client={client}>{element}</ApolloProvider>
)
